export const ERROR_UPLOAD_LOGO = "Ошибка при загрузке изображения.";
export const ERROR_DELETE_LOGO = "Ошибка при удалении логотипа.";